import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styled, { StyledComponentClass } from 'styled-components';
import 'event-propagation-path/propagationPath';

export interface Props {
  className?: string;
  onClick?: (e) => void;
  onClickAway: (e) => void;
  onScroll?: (e) => void;
}

class Dismissible extends React.Component<Props, any> {
  public static defaultProps: Partial<Props> = {
    onClick: () => null,
    onScroll: () => null,
  };

  private children = [];

  public componentDidMount() {
    window.addEventListener('click', this.handleClickOutside, true);
    window.addEventListener('scroll', this.handleScroll, true);
  }

  public componentWillUpdate(nextProps, nextState) {
    this.children = [];
  }

  public componentWillUnmount() {
    window.removeEventListener('click', this.handleClickOutside, true);
    window.removeEventListener('scroll', this.handleScroll, true);
  }

  public render() {
    const { className, children } = this.props;

    return (
      <div className={className} onClick={this.handleClick}>
        {React.Children.map(
          children,
          (child, i) =>
            child &&
            React.cloneElement(child as React.ReactElement<any>, {
              key: i,
              ref: el => (this.children[i] = el),
            }),
        )}
      </div>
    );
  }

  private handleClick = e => {
    e.stopPropagation();
    this.props.onClick(e);
  };

  private handleClickOutside = e => {
    const children = this.children.map(child => ReactDOM.findDOMNode(child));
    e.propagationPath().every(target => !(children as any).includes(target)) &&
      this.props.onClickAway(e);
  };

  private handleScroll = e => {
    this.props.onScroll(e);
  };
}

export default styled(Dismissible)`
  display: inline-flex;
  width: 100%;
  height: 100%;
`;
